import {
    ADD_STEP,
    DELETE_STEP,
    RECORD_STEP,
    MOVE_STEPS,
    DELETE_STEPS,
    DELETE_STEP_NUMBER,
    ALTER_STEP_PARAMETER,
    ALTER_TRACK_PARAMETER,
    TOGGLE_STEP,
    UPDATE_STEP_PARAMETER,
    DELETE_PATTERN,
    ADD_EFFECT,
    DELETE_EFFECT,
    TOGGLE_EFFECT,
    MOVE_EFFECT,
    UPDATE_PARAMETER,
    UPDATE_TRACK_VOLUME,
    UPDATE_TRACK_MUTE,
    ADD_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINT,
    MOVE_AUTOMATION_BREAK_POINTS,
    REMOVE_AUTOMATION_BREAK_POINT,
    REMOVE_AUTOMATION_BREAK_POINTS,
    SNAP_TO_GRID,
    SNAP_AUTOMATION_BREAK_POINT,
    RECORD_AUTOMATION,
    SMOOTH_AUTOMATION,
    LOAD_PROJECT_TRACKS,
    AUDITION_PRESET,
    UNMAP_PLANAR_PARAMETERS
} from './constants.js';

export const addStep =
    (track, step, stepNumber, resolution, displayResolution, slide) => ({
        type: ADD_STEP,
        payload: {
            track,
            step,
            stepNumber,
            resolution,
            displayResolution,
            slide
        }
    });

export const deleteStep =
    (track, step, stepNumber, resolution) => ({
        type: DELETE_STEP,
        timestamp: new Date().getTime(),
        payload: {
            track: track,
            step: step,
            stepNumber: stepNumber,
            resolution: resolution
        }
    });

export const deleteStepNumber =
    (track, stepNumber, resolution) => ({
        type: DELETE_STEP_NUMBER,
        timestamp: new Date().getTime(),
        payload: {
            track: track,
            stepNumber: stepNumber,
            resolution: resolution
        }
    });


export const recordStep =
    (track, step, stepNumber, resolution, displayResolution, isQuantized) => ({
        type: RECORD_STEP,
        timestamp: new Date().getTime(),
        payload: {
            track: track,
            step: step,
            stepNumber: stepNumber,
            resolution: resolution,
            displayResolution,
            isQuantized
        }
    });

export const toggleStep =
    (track, stepNumber, resolution) => ({
        type: TOGGLE_STEP,
        payload: {
            track: track,
            stepNumber: stepNumber,
            resolution: resolution
        }
    });


export const moveSteps =
    (track, steps, transformation, resolution, wrap=false, isPianoRoll=false) => ({
        type: MOVE_STEPS,
        payload: {
            track: track,
            steps: steps,
            transformation: transformation,
            wrap: wrap,
            resolution: resolution,
            isPianoRoll
        }
    });

export const deleteSteps =
    (track, steps) => ({
        type: DELETE_STEPS,
        payload: {
            track: track,
            steps: steps,
        }
    });

export const deletePattern =
    (patternNumber) => ({
        type: DELETE_PATTERN,
        payload: {
            patternNumber: patternNumber,
        }
    });

export const updateStepParameter =
    (track, step, parameter, value) => ({
        type: UPDATE_STEP_PARAMETER,
        payload: {
            track,
            step,
            parameter,
            value
        }
    });

export const addEffect =
    (effect, track, group, send) => ({
        type: ADD_EFFECT,
        payload: {
            effect,
            track,
            group,
            send
        }
    });

export const deleteEffect =
    (effect, track, group, send) => ({
        type: DELETE_EFFECT,
        payload: {
            effect,
            track,
            group,
            send
        }
    });

export const toggleEffect =
    (effect, track, group, send) => ({
        type: TOGGLE_EFFECT,
        payload: {
            effect,
            track,
            group,
            send
        }
    });

export const moveEffect =
    (from, to, isMidiEffect, track, group, send) => ({
        type: MOVE_EFFECT,
        payload: {
            from,
            to,
            isMidiEffect,
            track,
            group,
            send
        }
    });

export const updateParameter =
    (parameter, value, automation=false, isBulk=false) => ({
        type: UPDATE_PARAMETER,
        timestamp: new Date().getTime(),
        payload: {
            parameter,
            value,
            automation,
            isBulk
        }
    });

export const updateTrackVolume =
    (track, value) => ({
        type: UPDATE_TRACK_VOLUME,
        payload: {
            track,
            value
        }
    });

export const updateTrackMute =
    (track, mute) => ({
        type: UPDATE_TRACK_MUTE,
        payload: {
            track,
            mute
        }
    });

export const addAutomationBreakpoint =
    (automation, step, value, pointId) => ({
        type: ADD_AUTOMATION_BREAK_POINT,
        payload: {
            automation,
            step,
            value,
            pointId,
        }
    });

export const moveAutomationBreakpoint =
    (automation, point, step, value) => ({
        type: MOVE_AUTOMATION_BREAK_POINT,
        payload: {
            automation,
            point,
            step,
            value
        }
    });

export const removeAutomationBreakpoint =
    (automation, point) => ({
        type: REMOVE_AUTOMATION_BREAK_POINT,
        payload: {
            automation,
            point
        }
    });

export const removeAutomationBreakPoints=
    (automation, points) => ({
        type: REMOVE_AUTOMATION_BREAK_POINTS,
        payload: {
            automation,
            points
        }
    });

export const moveAutomationBreakPoints=
    (automation, points, stepDiff, valueDiff) => ({
        type: MOVE_AUTOMATION_BREAK_POINTS,
        payload: {
            automation,
            points,
            stepDiff,
            valueDiff
        }
    });

export const snapToGrid =
    (track, steps, resolution) => ({
        type: SNAP_TO_GRID,
        payload: {
            track,
            steps,
            resolution
        }
    });

export const snapAutomationBreakPoint =
    (automation, point) => ({
        type: SNAP_AUTOMATION_BREAK_POINT,
        payload: {
            automation,
            point
        }
    });

export const recordAutomation = (parameter, automation, value, oldValue) => ({
    type: RECORD_AUTOMATION,
    timestamp: new Date().getTime(),
    payload:  {
        parameter,
        automation,
        value,
        oldValue
    }
});

export const loadProjectTracks = (tracks, patternToLoad) => ({
    type: LOAD_PROJECT_TRACKS,
    payload:  {
        tracks,
        patternToLoad
    }
});

export const auditionPreset = (preset, track, loadMods, loadEffects) => ({
    type: AUDITION_PRESET,
    payload: {
        track,
        preset,
        loadMods,
        loadEffects
    }
});

export const unmapPlanarParameters = (effect, parameters) => ({
    type: UNMAP_PLANAR_PARAMETERS,
    payload: {
        effect,
        parameters
    }
});





